module.exports = __webpack_public_path__ + "static/media/logo-gradient.472c5872.png";